import { render, staticRenderFns } from "./moreQA.vue?vue&type=template&id=1e3ea16f&scoped=true&"
import script from "./moreQA.vue?vue&type=script&lang=js&"
export * from "./moreQA.vue?vue&type=script&lang=js&"
import style0 from "./moreQA.vue?vue&type=style&index=0&id=1e3ea16f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ea16f",
  null
  
)

export default component.exports